import { customElement } from "lit/decorators.js";
import { DodonaElement } from "@/components/meta/dodona_element";
import { updateURLParameter } from "@/utilities";

/**
 * Wraps the select that picks the language of an activity description, and reloads the page
 * with the chosen `description_language`.
 *
 * Renders no template of its own.
 *
 * @element d-description-language-select
 */
@customElement("d-description-language-select")
export class DescriptionLanguageSelect extends DodonaElement {
    connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener("change", this.onChange);
    }

    private onChange = (event: Event): void => {
        const { value } = event.target as HTMLSelectElement;
        window.location.href = updateURLParameter(window.location.href, "description_language", value);
    };
}
